import {User} from "@/types";
import {ActionContext} from "vuex";
import {RootState} from "@/store/types";

export interface State {
    token: string,
    error: string,
    user_info: User | null,
    user_position: string | null,
    user_position_bid: number | null,
    loader: boolean,
    reset_step: ResetStepValues
}

// noinspection JSUnusedGlobalSymbols
export enum ResetStepValues {
    Step1 = 1,
    Step2,
    Step3,
    Step4,
    Step5
}

export interface Auth {
    login: string,
    email: string,
    password: string
}

export interface StartResetPassword {
    email: string
    snils: string
}

export interface ResetPassword {
    newPassword: string;
    type: 'force' | 'soft'
}

export interface Getters {
    loginError(state: State): string;
    loader(state: State): boolean;
    userData(state: State): User | null;
    userName(state: State): string | null;
    userPosition(state: State): string | null;
    getPasswordResetStep(state: State): number;
}

export interface Mutations {
    setToken(state: State, payload: string): void;
    setError(state: State, payload: string): void;
    setUser(state: State, payload: User): void;
    setLoader(state: State, payload: boolean): void;
    setPasswordResetStep(state: State, step: number): void;
}

export interface Actions {
    login(context: ActionContext<State, RootState>, user: Auth): Promise<void>;
    loginTest(context: ActionContext<State, RootState>, user: Auth): Promise<void>;
    logout(context: ActionContext<State, RootState>): Promise<void>;
    userInfo(context: ActionContext<State, RootState>): Promise<void>;
    startReset(context: ActionContext<State, RootState>, payload: StartResetPassword): Promise<void>;
    phoneInput(context: ActionContext<State, RootState>, phone: string): Promise<void>;
    confirmCode(context: ActionContext<State, RootState>, code: string): Promise<void>;
    resetPass(context: ActionContext<State, RootState>, payload: ResetPassword): Promise<void>;
}